<template>
  <el-form-item
    :label="label"
    class="invoice-address"
    :prop="prop"
    :rules="rules"
  >
    <el-input
      v-model="invoiceAddress"
      type="textarea"
      :clearable="true"
      :maxlength="135"
      resize="none"
      :placeholder="placeholder"
      :disabled="disabled"
      :autofocus="autofocus"
    />
  </el-form-item>
</template>

<script>
import Validator from '@/mixins/Validator.vue'

export default {
  components: {
  },
  mixins: [
    Validator
  ],
  props: {
    value: String,
    label: {
      type: String,
      default: '請求先宛名'
    },
    prop: {
      type: String,
      default: 'invoice_address'
    },
    required: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    autofocus: {
      type: Boolean,
      default: false
    },
    searchCond: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      placeholder: this.searchCond ? '前方一致' : '最大135文字'
    }
  },
  computed: {
    invoiceAddress: {
      get () {
        return this.value
      },
      set (invoiceAddress) {
        this.$emit('input', invoiceAddress)
      }
    },
    rules: {
      get () {
        const rules = []
        if (!this.disabled) {
          if (this.required) {
            rules.push(this.validatorRequired(this.label, 'blur'))
          }
        }
        return rules
      }
    }
  },
  methods: {
  }
}
</script>

<style lang="scss">
</style>
